import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./css/style.css";

export default function EndApp() {
  useEffect(() => {
    setTimeout(() => {
      mobileDeviceControl();
    }, 1500);
    return () => {};
  }, []);

  const mobileDeviceControl = () => {
    try {
      console.log("mobileDeviceControl", "end");
      window.webkit.messageHandlers.closeRating.postMessage("close");
    } catch (error) {}
    try {
      window.Android.closeRating();
    } catch (error) {}
  };

  return (
    <div className="container rate-container">
      <div className="row">
        <div className="offset-md-1 col-md-10">
          <div className="header-rating">การประเมินความพึงพอใจในการให้บริการของเจ้าหน้าที่ในการให้บริการ</div>
          <div className="header-rating">เพื่อนำผลการประเมินไปปรับปรุง และแก้ไขการให้บริการของเจ้าหน้าที่ให้ดียิ่งขึ้น</div>
          <br />
        </div>
      </div>
      <div className="row">
        <div className="offset-md-1 col-md-10">
          <br />
          <br />
          <div className="field-end">
            <h3>ขอบคุณสำหรับข้อเสนอแนะ</h3>
          </div>
        </div>
      </div>
    </div>
  );
}
